<script lang="ts">import Negative from "./images/negative.png";
import Positive from "./images/positive.png";
import { t, Verbiage } from "@infinitro/content";
import { CurrencyIcon } from "@infinitro/icons";
import { InfoCard } from "@infinitro/info-card";
import { asCurrencyIconCode } from "./types";
let { item = {
	name: "ETH",
	price: "45,000"
} } = $props();
</script>

<InfoCard
	noPadding
	width="120px"
	height="70px"
	highlight={true}
	glowColor={item.positive === true
		? 'rgba(110, 231, 56, 0.7)'
		: item.positive === false
			? 'rgba(223, 28, 65, 0.7)'
			: 'rgba(87, 119, 255, 1)'}
>
	<div class="icon-bg">
		<CurrencyIcon currency={asCurrencyIconCode(item.name)} size="90" />
	</div>
	<div class="item">
		<div class="card-row">
			<div class="crypto-icon-container">
				<CurrencyIcon currency={asCurrencyIconCode(item.name)} size="23" />
			</div>
			<div class="crypto-info">
				<p class="crypto-name">{item.name}</p>
				{#if item.percentage}
					<p class="crypto-percentage {item.positive ? 'positive' : 'negative'}">
						<span>{item.percentage}</span>
						<img
							src={item.positive ? Positive : Negative}
							alt={$t(Verbiage.percentage_alt, 'alts')}
							class="w-4 h-4"
						/>
					</p>
				{/if}
			</div>
		</div>
		<div class="card-row align-start">
			<span class="crypto-price">{item.price}</span>
		</div>
	</div>
</InfoCard>

<style>
	.card-row {
		display: flex;
		height: 50%;
		width: 100%;
		align-items: center;
		justify-content: center
}
	.align-start {
		margin-left: 7px;
		justify-content: flex-start
}
	.item {
		position: relative;
		height: 100%;
		width: 100%;
		cursor: pointer;
		overflow: hidden;
		border-radius: 1rem;
		padding: 0.375rem;
		transition-property: all;
		transition-duration: 200ms;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transform-style: preserve-3d
}
	.icon-bg {
		position: absolute;
		top: 20px;
		left: 40px;
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: center;
		opacity: 0.2
}
	.crypto-info {
		position: relative;
		display: flex;
		width: 65%;
		flex-direction: column;
		padding-top: 0.25rem;
		font-family: var(--font-main)
}
	.crypto-icon-container {
		display: flex;
		height: 100%;
		width: 35%;
		align-items: center;
		justify-content: center
}
	.crypto-name {
		font-size: 0.75rem;
		line-height: 1rem;
		--tw-text-opacity: 1;
		color: rgb(209 213 219 / var(--tw-text-opacity, 1))
}
	.crypto-percentage {
		display: flex;
		align-items: center;
		gap: 0.25rem;
		font-size: 0.75rem;
		line-height: 1rem
}
	.positive {
		color: var(--color-success-500);
		text-shadow: 0 0 5px rgba(110, 231, 56, 0.7)
}
	.negative {
		color: var(--color-error-500);
		text-shadow: 0 0 5px rgba(223, 28, 65, 0.7)
}
	.crypto-price {
		margin-top: 0.75rem;
		text-align: center;
		font-size: 0.875rem;
		line-height: 1.25rem;
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main)
}
</style>
